<div>
    <fm-pivot #pivot [licenseKey]="key"  [report]="report" [toolbar]="true" [height]="600"
        (beforetoolbarcreated)="customizeToolbar($event)"></fm-pivot>
</div>
